import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import UpdateCategoryRequest from '../../../Spirit/Admin/Interfaces/Models/MeditationService/UpdateCategoryRequest';
import FilterRequest from '../../../Spirit/Common/Extensions/Models/FilterRequest';
import ChangeSortIndexRequest from '../../../Spirit/Common/Helpers/Models/ChangeSortIndexRequest';
import UpdateMeditationRequest from '../../../Spirit/Admin/Interfaces/Models/MeditationService/UpdateMeditationRequest';
import MeditationsRequest from '../../../Spirit/Admin/Interfaces/Models/MeditationService/MeditationsRequest';
import MeditationNoteByIdRequest from '../../../Spirit/Admin/Interfaces/Models/MeditationService/MeditationNoteByIdRequest';
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';
import PaginationResponseT from '../../../Common/ResponseModels/PaginationResponseT';
import CategoryResponse from '../../../Spirit/Admin/Interfaces/Models/MeditationService/CategoryResponse';
import MeditationDetailResponse from '../../../Spirit/Admin/Interfaces/Models/MeditationService/MeditationDetailResponse';
import MeditationResponse from '../../../Spirit/Admin/Interfaces/Models/MeditationService/MeditationResponse';
import MeditationNoteResponse from '../../../Spirit/Admin/Interfaces/Models/MeditationService/MeditationNoteResponse';

export default class MeditationService {
	webApiService: WebApiService;
	UpdateCategoryEvent = new Events<WsResponseModelT<Boolean>>();
	GetCategoriesEvent = new Events<WsResponseModelT<PaginationResponseT<CategoryResponse>>>();
	ChangeSortIndexEvent = new Events<WsResponseModelT<Boolean>>();
	GetCategoryEvent = new Events<WsResponseModelT<CategoryResponse>>();
	DeleteCategoryEvent = new Events<WsResponseModelT<Boolean>>();
	DeleteMeditationEvent = new Events<WsResponseModelT<Boolean>>();
	UpdateMeditationEvent = new Events<WsResponseModelT<Boolean>>();
	GetMeditationEvent = new Events<WsResponseModelT<MeditationDetailResponse>>();
	GetMeditationsEvent = new Events<WsResponseModelT<PaginationResponseT<MeditationResponse>>>();
	ToggleIsPaidEvent = new Events<WsResponseModelT<Boolean>>();
	ToggleIsSleepEvent = new Events<WsResponseModelT<Boolean>>();
	ToggleUseBackgroundMusicEvent = new Events<WsResponseModelT<Boolean>>();
	ToggleUseOnMainDisplayEvent = new Events<WsResponseModelT<Boolean>>();
	GetMeditationNotesByIdEvent = new Events<WsResponseModelT<PaginationResponseT<MeditationNoteResponse>>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('MeditationService', 'UpdateCategory', (res: WsResponseModelT<Boolean>) => {
			self.UpdateCategoryEvent.trigger(res);
		});
		webApiService.on('MeditationService', 'GetCategories', (res: WsResponseModelT<PaginationResponseT<CategoryResponse>>) => {
			self.GetCategoriesEvent.trigger(res);
		});
		webApiService.on('MeditationService', 'ChangeSortIndex', (res: WsResponseModelT<Boolean>) => {
			self.ChangeSortIndexEvent.trigger(res);
		});
		webApiService.on('MeditationService', 'GetCategory', (res: WsResponseModelT<CategoryResponse>) => {
			self.GetCategoryEvent.trigger(res);
		});
		webApiService.on('MeditationService', 'DeleteCategory', (res: WsResponseModelT<Boolean>) => {
			self.DeleteCategoryEvent.trigger(res);
		});
		webApiService.on('MeditationService', 'DeleteMeditation', (res: WsResponseModelT<Boolean>) => {
			self.DeleteMeditationEvent.trigger(res);
		});
		webApiService.on('MeditationService', 'UpdateMeditation', (res: WsResponseModelT<Boolean>) => {
			self.UpdateMeditationEvent.trigger(res);
		});
		webApiService.on('MeditationService', 'GetMeditation', (res: WsResponseModelT<MeditationDetailResponse>) => {
			self.GetMeditationEvent.trigger(res);
		});
		webApiService.on('MeditationService', 'GetMeditations', (res: WsResponseModelT<PaginationResponseT<MeditationResponse>>) => {
			self.GetMeditationsEvent.trigger(res);
		});
		webApiService.on('MeditationService', 'ToggleIsPaid', (res: WsResponseModelT<Boolean>) => {
			self.ToggleIsPaidEvent.trigger(res);
		});
		webApiService.on('MeditationService', 'ToggleIsSleep', (res: WsResponseModelT<Boolean>) => {
			self.ToggleIsSleepEvent.trigger(res);
		});
		webApiService.on('MeditationService', 'ToggleUseBackgroundMusic', (res: WsResponseModelT<Boolean>) => {
			self.ToggleUseBackgroundMusicEvent.trigger(res);
		});
		webApiService.on('MeditationService', 'ToggleUseOnMainDisplay', (res: WsResponseModelT<Boolean>) => {
			self.ToggleUseOnMainDisplayEvent.trigger(res);
		});
		webApiService.on('MeditationService', 'GetMeditationNotesById', (res: WsResponseModelT<PaginationResponseT<MeditationNoteResponse>>) => {
			self.GetMeditationNotesByIdEvent.trigger(res);
		});
	}
	UpdateCategory(request: UpdateCategoryRequest = null) { 	
        this.webApiService.send('MeditationService', 'UpdateCategory' , request);
    }
	GetCategories(request: FilterRequest = null) { 	
        this.webApiService.send('MeditationService', 'GetCategories' , request);
    }
	ChangeSortIndex(request: ChangeSortIndexRequest = null) { 	
        this.webApiService.send('MeditationService', 'ChangeSortIndex' , request);
    }
	GetCategory(id: number = 0) { 	
        this.webApiService.send('MeditationService', 'GetCategory' , id);
    }
	DeleteCategory(id: number = 0) { 	
        this.webApiService.send('MeditationService', 'DeleteCategory' , id);
    }
	DeleteMeditation(id: number = 0) { 	
        this.webApiService.send('MeditationService', 'DeleteMeditation' , id);
    }
	UpdateMeditation(request: UpdateMeditationRequest = null) { 	
        this.webApiService.send('MeditationService', 'UpdateMeditation' , request);
    }
	GetMeditation(id: number = 0) { 	
        this.webApiService.send('MeditationService', 'GetMeditation' , id);
    }
	GetMeditations(request: MeditationsRequest = null) { 	
        this.webApiService.send('MeditationService', 'GetMeditations' , request);
    }
	ToggleIsPaid(id: number = 0) { 	
        this.webApiService.send('MeditationService', 'ToggleIsPaid' , id);
    }
	ToggleIsSleep(id: number = 0) { 	
        this.webApiService.send('MeditationService', 'ToggleIsSleep' , id);
    }
	ToggleUseBackgroundMusic(id: number = 0) { 	
        this.webApiService.send('MeditationService', 'ToggleUseBackgroundMusic' , id);
    }
	ToggleUseOnMainDisplay(id: number = 0) { 	
        this.webApiService.send('MeditationService', 'ToggleUseOnMainDisplay' , id);
    }
	GetMeditationNotesById(request: MeditationNoteByIdRequest = null) { 	
        this.webApiService.send('MeditationService', 'GetMeditationNotesById' , request);
    }
	 // async methods
	async updateCategoryAsync(request: UpdateCategoryRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.UpdateCategory.bind(this), this.UpdateCategoryEvent)(request);
	}
	async getCategoriesAsync(request: FilterRequest = null): Promise<PaginationResponseT<CategoryResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetCategories.bind(this), this.GetCategoriesEvent)(request);
	}
	async changeSortIndexAsync(request: ChangeSortIndexRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.ChangeSortIndex.bind(this), this.ChangeSortIndexEvent)(request);
	}
	async getCategoryAsync(id: number = 0): Promise<CategoryResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetCategory.bind(this), this.GetCategoryEvent)(id);
	}
	async deleteCategoryAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.DeleteCategory.bind(this), this.DeleteCategoryEvent)(id);
	}
	async deleteMeditationAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.DeleteMeditation.bind(this), this.DeleteMeditationEvent)(id);
	}
	async updateMeditationAsync(request: UpdateMeditationRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.UpdateMeditation.bind(this), this.UpdateMeditationEvent)(request);
	}
	async getMeditationAsync(id: number = 0): Promise<MeditationDetailResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetMeditation.bind(this), this.GetMeditationEvent)(id);
	}
	async getMeditationsAsync(request: MeditationsRequest = null): Promise<PaginationResponseT<MeditationResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetMeditations.bind(this), this.GetMeditationsEvent)(request);
	}
	async toggleIsPaidAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.ToggleIsPaid.bind(this), this.ToggleIsPaidEvent)(id);
	}
	async toggleIsSleepAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.ToggleIsSleep.bind(this), this.ToggleIsSleepEvent)(id);
	}
	async toggleUseBackgroundMusicAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.ToggleUseBackgroundMusic.bind(this), this.ToggleUseBackgroundMusicEvent)(id);
	}
	async toggleUseOnMainDisplayAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.ToggleUseOnMainDisplay.bind(this), this.ToggleUseOnMainDisplayEvent)(id);
	}
	async getMeditationNotesByIdAsync(request: MeditationNoteByIdRequest = null): Promise<PaginationResponseT<MeditationNoteResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetMeditationNotesById.bind(this), this.GetMeditationNotesByIdEvent)(request);
	}
}